<router-outlet></router-outlet>
<ngx-guided-tour skipText="Fechar" nextText="Próximo" backText="Voltar" doneText="Fim"></ngx-guided-tour>